import type { AutoAriaLabelElementProps } from "../common/customElement/extend.useOcAutoAriaLabel.ts";
import { setAriaLabel } from "./setAriaLabel.ts";

export const resolveOcAuto = (ev: Event): void => {
  const target = ev.target as HTMLElement & AutoAriaLabelElementProps;
  if (!target.__ocAutoAriaLabel && target.ariaLabel !== "oc-auto") return;

  const Host = target.parentElement;
  if (!Host) return;
  setAriaLabel(target, Host);
};
